import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <div style={{display: 'flex', flexDirection: 'row'}}>
      <App />
    </div>
  </React.Fragment>
);

